export default "__VITE_ASSET__Dhd1PulI__"